module.exports = __webpack_public_path__ + "static/level4-3f8ea74a8473fb70d44e0972e0cf671c.png";